/**
 * UI controls for visit-status filters and map actions.
 */

import { setActiveVisitStatus } from './state.js';
import { requestUserLocation } from './geolocation.js';
import { updateMarkerVisibility } from './marker-visibility.js';

/**
 * Wires the "My location" button.
 *
 * @return {void}
 */
export function bindMapControls() {
	const myLocationBtn = document.getElementById( 'sumy-map-my-location' );
	if ( myLocationBtn ) {
		myLocationBtn.addEventListener( 'click', () => {
			requestUserLocation( { force: true } );
		} );
	}
}

/**
 * Wires visit-status filter buttons.
 *
 * @return {void}
 */
export function bindViewButtons() {
	const views = document.querySelectorAll(
		'.sumy-neighborhood-map__visit-status'
	);
	for ( let i = 0; i < views.length; i++ ) {
		views[ i ].addEventListener( 'click', changeView );
	}
}

/**
 * Makes info-window content navigate on click (dialog role wrapper).
 *
 * @return {void}
 */
export function bindInfoWindowNavigation() {
	document.addEventListener( 'click', ( event ) => {
		const where = event.target.closest( "[role='dialog']" );
		if ( ! where ) {
			return;
		}
		const link = where.querySelector( 'a' );
		const href = link?.href;
		if ( href ) {
			window.location.href = href;
		}
	} );
}

/**
 * Changes the visit-status filter highlight and refreshes marker visibility.
 *
 * @param {Event} event Click event from a visit-status button.
 * @return {void}
 */
function changeView( event ) {
	const visitStatus = this.dataset.visit_status;
	const views = document.querySelectorAll(
		'.sumy-neighborhood-map__visit-status'
	);

	for ( let j = 0; j < views.length; j++ ) {
		views[ j ].classList.remove( 'btn-primary' );
	}

	this.classList.add( 'btn-primary' );
	setActiveVisitStatus( visitStatus );
	updateMarkerVisibility();
}
